import { Button, ButtonProps, SxProps, Theme } from '@mui/material';

import * as Styles from './RoundedIconButton.styles';

export const RoundedIconButton = (props: ButtonProps) => (
  <Button {...props} sx={{ ...Styles.Button(props.size), ...props.sx } as SxProps<Theme>} />
);
